/* eslint-disable @typescript-eslint/no-require-imports */
import throwUnsupportedError from "$src/core/utils/error/throw-unsupported-error";
import CustomPlatform from "$src/core/utils/platform/platform";

import type { Toaster as ToasterType, Alerting as AlertingType } from "./types";

export const Toaster = CustomPlatform.select<() => ToasterType>({
  web: () => require("./alerting.web").Toaster,
  native: () => require("./alerting").Toaster,
  tv: () => () => null,
  default: () => throwUnsupportedError("Toaster"),
})();

const Alerting = CustomPlatform.select<() => AlertingType>({
  native: () => require("./alerting").alerting,
  tv: () => require("./alerting.tv").alerting,
  web: () => require("./alerting.web").alerting,
  default: () => throwUnsupportedError("Alerting"),
})();

export default Alerting;
